import { createClient } from '@supabase/supabase-js'
import type { Database } from '../types/database'

const url = import.meta.env.VITE_SUPABASE_URL
const key = import.meta.env.VITE_SUPABASE_ANON_KEY
export const isConfigured = Boolean(url && key && !url.includes('your-project'))
export const supabase = createClient<Database>(url || 'https://placeholder.supabase.co', key || 'placeholder-key')
